import { css } from '@emotion/css';

export const setTableHeightStyles = (height: number) => css`
  height: ${height}px !important;
`;

export const tableStyles = css`
  /**
   *  Direction RTL for Row and Header for base-table, dir in HTML doesn't seem to work for this
   *  https://github.com/Autodesk/react-base-table/issues/98
   */
  [dir='rtl'] & .BaseTable__row,
  [dir='rtl'] & .BaseTable__header {
    direction: rtl;
  }

  margin-bottom: 7.2rem;

  .BaseTable__body {
    height: 100% !important;
  }

  .BaseTable__table-frozen-left {
    height: auto !important;
  }

  .BaseTable__table-frozen-right {
    height: auto !important;
  }

  .BaseTable__row,
  .BaseTable__body > div,
  .BaseTable__header > div {
    min-width: 100%;
  }

  .BaseTable__table-main {
    border-radius: 8px 8px 0px 0px;
  }

  .BaseTable__header {
    border-radius: 8px 8px 0px 0px;
  }
`;

export const commonTableStyles = css`
  [dir='rtl'] & .BaseTable__row,
  [dir='rtl'] & .BaseTable__header {
    direction: rtl;
  }

  &.BaseTable {
    box-shadow: none;

    .BaseTable__table,
    .BaseTable__row,
    .BaseTable__footer,
    .BaseTable__body {
      background-color: var(--bg-primary);
    }

    .BaseTable__table-main {
      outline: none;
    }

    .BaseTable__body {
      will-change: unset !important;
    }

    .BaseTable__column-resizer {
      width: 2px;
      background: var(--focus-primary) !important;
    }

    .BaseTable__table-main .BaseTable__header {
      background: var(--bg-primary);
    }
  }
`;

export const tableFooterStyles = css`
  .BaseTable__table-main {
    border-radius: 8px 8px 0px 0px;
    outline: none;
    border: 1px solid var(--border);
    border-bottom: 0px;
  }

  .BaseTable__header {
    border-radius: 8px 8px 8px 0px;
  }
`;
